module.exports = __webpack_public_path__ + "static/1-insights-7166775b07fe9ffa22c734a99cd60790.jpg";